import styles from './PageContact.module.css'
import Questions from '../../components/Questions/Questions';

function PageContact() {
  return (
    <div className={styles.PageContact}>
      <div className={styles.CodeAblazeTitle}>
        <h1>Contact Us</h1>
      </div>
      <div className={styles.ContentDiv}>
        <div className={styles.DescriptionDiv}>
          If you have any suggestions or questions, please contact us at
          <span> </span>
          <a href="mailto:codeablazeprogram@gmail.com">codeablazeprogram@gmail.com</a>.
          <span> </span>
          We'd love to hear from you!
          <br />
          <br />
          <div className={styles.FAQHeader}>
            Frequently Asked Questions
          </div>
          <div className={styles.FAQHolder}>
            <Questions />
          </div>
          <div className={styles.Spacing} />
        </div>
      </div>
    </div>
  );
}

export default PageContact;
